/** Converts string to lowercase and removes all accents/diacritics */
export const normalizeStr = (str: string) =>
	str
		.toLowerCase()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '');
